export default function Products() {
  const products = [
    {
      icon: 'ri-plant-line',
      title: 'Verduras Frescas',
      description: 'Alface, rúcula, couve, espinafre e muito mais, colhidos diariamente',
    },
    {
      icon: 'ri-apple-line',
      title: 'Frutas Selecionadas',
      description: 'Frutas da estação com qualidade premium e sabor incomparável',
    },
    {
      icon: 'ri-seedling-line',
      title: 'Legumes Premium',
      description: 'Tomate, cenoura, batata, abobrinha e variedades especiais',
    },
    {
      icon: 'ri-leaf-line',
      title: 'Temperos Frescos',
      description: 'Manjericão, salsinha, cebolinha e ervas aromáticas',
    },
    {
      icon: 'ri-restaurant-line',
      title: 'Produtos Orgânicos',
      description: 'Linha especial de produtos cultivados sem agrotóxicos',
    },
    {
      icon: 'ri-shopping-basket-line',
      title: 'Cestas Personalizadas',
      description: 'Monte sua cesta com os produtos que você mais gosta',
    },
  ];

  return (
    <section id="products" className="py-16 sm:py-20 md:py-24 bg-gradient-to-b from-white to-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        <div className="text-center mb-12 sm:mb-16">
          <span className="text-[#9bc53d] text-sm font-semibold tracking-wider uppercase">Nossos Produtos</span>
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-[#2d5016] mt-4 mb-4 sm:mb-6">
            Qualidade Premium
          </h2>
          <p className="text-gray-600 text-base sm:text-lg max-w-2xl mx-auto px-4">
            Produtos cuidadosamente selecionados para garantir o melhor para você e sua família
          </p>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6 sm:gap-8">
          {products.map((product, index) => (
            <div
              key={index}
              className="bg-white rounded-2xl p-6 sm:p-8 shadow-lg hover:shadow-2xl transition-all duration-300 hover:-translate-y-2 group"
            >
              <div className="w-14 h-14 sm:w-16 sm:h-16 bg-gradient-to-br from-[#9bc53d] to-[#2d5016] rounded-2xl flex items-center justify-center mb-4 sm:mb-6 group-hover:scale-110 transition-transform duration-300">
                <i className={`${product.icon} text-2xl sm:text-3xl text-white`}></i>
              </div>
              <h3 className="text-lg sm:text-xl font-bold text-[#2d5016] mb-2 sm:mb-3">
                {product.title}
              </h3>
              <p className="text-gray-600 leading-relaxed text-sm sm:text-base">
                {product.description}
              </p>
            </div>
          ))}
        </div>

        <div className="text-center mt-8 sm:mt-12">
          <a
            href="https://pedido.anota.ai/loja/rancho-das-verduras-2"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-block bg-[#9bc53d] text-white px-8 sm:px-10 py-3 sm:py-4 rounded-full text-base sm:text-lg font-semibold hover:bg-[#2d5016] transition-all duration-300 shadow-lg hover:shadow-xl whitespace-nowrap"
          >
            Ver Todos os Produtos
          </a>
        </div>
      </div>
    </section>
  );
}
